import React from 'react';

import { bool, func, string } from 'prop-types';
import {
  Item,
  ItemSelected,
  ItemIcon,
  ItemLabel,
  ItemShow,
} from './styles';

const SidebarItem = (props) => {
  const {
    onSidebarItemClicked, icon, label, active,
  } = props;

  const onItemClicked = () => {
    onSidebarItemClicked();
  };

  return (
    <>
      {!active && (
        <Item onClick={onItemClicked}>
          <ItemIcon name={icon} />
          <ItemLabel>{label}</ItemLabel>
        </Item>
      )}
      {active && (
        <ItemSelected>
          <ItemIcon name={icon} />
          <ItemLabel>{label}</ItemLabel>
          <ItemShow />
        </ItemSelected>
      )}
    </>
  );
};

SidebarItem.propTypes = {
  active: bool.isRequired,
  icon: string.isRequired,
  label: string.isRequired,
  onSidebarItemClicked: func.isRequired,
};

export default SidebarItem;
